import Grid from '@mui/material/Grid';

export const AuthBackgroundImage: React.FC = () => {
  return (
    <Grid
      item
      display={{ xs: 'none', lg: 'flex' }}
      lg={7}
      sx={{
        background: 'linear-gradient(to bottom, #492f84, #36336a, #111d2d)',
        justifyContent: 'flex-end',
        overflow: 'hidden',
      }}
    >
      <img
        src="/assets/images/login-background.webp"
        alt="Vayu login background"
        style={{
          maxWidth: '100vw',
          maxHeight: '100vh',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      />
    </Grid>
  );
};